(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('AdvertisingSourceFinancialReport', AdvertisingSourceFinancialReport);

    AdvertisingSourceFinancialReport.$inject = ['$resource'];

    function AdvertisingSourceFinancialReport ($resource) {
        var resourceUrl =  'api/report/advertising-source-financial/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
